export default "__VITE_ASSET__PLa8uYVJ__"